import { type ReactNode } from 'react';

import { type SizeType } from '../../features/config';
import { type IconName } from '../Icon';

export enum CHIP_STATUS {
    accepted = 'accepted',
    active = 'active',
    alert = 'alert',
    closed = 'closed',
    created = 'created',
    danger = 'danger',
    done = 'done',
    draft = 'draft',
    inApproval = 'in-approval',
    inProgress = 'in-progress',
    inactive = 'inactive',
    invited = 'invited',
    notPublished = 'not-published',
    open = 'open',
    published = 'published',
    review = 'review',
    scheduled = 'scheduled',
    success = 'success',
    unpublishedReady = 'unpublished-ready',
    warning = 'warning'
}

export enum ChipType {
    Avatar = 'avatar',
    CustomIcon = 'customIcon',
    Default = 'default',
    Group = 'group',
    Status = 'status'
}

export enum StatusSize {
    LARGE = 'lg',
    SMALL = 'sm'
}

export type ChipGroup = {
    backgroundColor: string;
    initials: string;
};

export type ChipProps = {
    avatar?: string | never;
    background?: boolean | never;
    noPadding?: boolean;
    className?: string;
    color?: string;
    group?: ChipGroup | never;
    statusSize?: SizeType;
    status?: CHIP_STATUS | never;
    text: string;
    textRender?: (text: string) => ReactNode;
    tooltip?: string;
    truncate?: boolean;
    type?: ChipType;
    maxChipLength?: number;
} & {
    icon?: IconName | null;
    customIcon?: IconName;
    onClick?: () => void;
};
